import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const InboxIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.76 3H7.24a3 3 0 0 0-2.68 1.66L1.1 11.54A1 1 0 0 0 1 12v6a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6a.97.97 0 0 0-.11-.47l-3.44-6.86A3 3 0 0 0 16.75 3Zm3.62 8-2.72-5.44a1 1 0 0 0-.9-.56H7.24a1 1 0 0 0-.9.55L3.62 11H8a1 1 0 0 1 .83.45l1.7 2.55h2.93l1.7-2.55A1 1 0 0 1 16 11h4.38ZM3 13v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5h-4.46l-1.7 2.55A1 1 0 0 1 14 16h-4a1 1 0 0 1-.83-.45L7.47 13H3Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default InboxIcon;
